export var extension = function extension(attrs) {
  return {
    type: 'extension',
    attrs: attrs
  };
};